// #region imports

// --- Angular
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// --- RxJs
import { combineLatest, map } from 'rxjs';

// --- HS Code
import { OidcService } from '../services';

// #endregion
export const participantGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const oidcService: OidcService = inject(OidcService);
  const router: Router = inject(Router);

  return combineLatest([
    oidcService.isParticipant$,
    oidcService.isRespondent$,
    oidcService.claims$
  ]).pipe(
    map(([isParticipant, isRespondent]) => {

      if (!isParticipant) {
        if (isRespondent) {
          return router.createUrlTree(['/respondent']);
        } else {
          return router.createUrlTree(['/']);
        }
      }

      return true;
    })
  );
}
